export default {
    messageTimeout: 3000,
    animation: 'slideInRight',
    appLogoIcon:
        'https://pacific-screening.imgix.net/company-logos/rentwell-logo-mark.jpg?width=35&q=70',
    appLogoText:
        'https://pacific-screening.imgix.net/company-logos/rentwell-logo.jpg?width=250&q=90',
    companyBackgroundImg:
        'https://pacific-screening-static.s3.amazonaws.com/images/company-background-sm.png',
    companyName: 'Rent Well',
    layoutColors: {
        containerBackground: 'primary lighten-2',
        sideBarBackground: 'alternate3 darken-5',
        sideBarItemText: 'white--text',
        sideBarGroupText: 'white--text ',
        activeSideBarItemText: 'primary--text text--lighten-3',
        activeGroupItemClass: 'primary lighten-1 primary--text text--lighten-4',
        footerBackground: 'primary darken-2',
    },
    colorTheme: {
        primary: {
            primary: '#006b6e',
            accent: '#4d8198',
            secondary: '#35b4cb',
            error: '#BF360C',
            info: '#6EB2C4',
            success: '#84D9BD',
            warning: '#FFC107',
            alternate1: '#58bbc6',
            alternate3: '#003537',
            alternate2: '#286087',
            alternate4: '#74a03a',
            alternate5: '#5cbfc5',
            //      BandwidthChart: BandwidthChart,
        },
        secondary: {
            primary: '#006b6e',
            accent: '#4d8198',
            secondary: '#35b4cb',
            error: '#BF360C',
            info: '#6EB2C4',
            success: '#84D9BD',
            warning: '#FFC107',
            alternate1: '#58bbc6',
            alternate3: '#003537',
            alternate2: '#286087',
            alternate4: '#74a03a',
            alternate5: '#5cbfc5',
        },
    },
};
